import React, { createContext, useContext, useState } from 'react';

const ProgramContext = createContext({
  program: 'ISET',
  setProgram: () => {}
});

export const useProgram = () => useContext(ProgramContext);

export const ProgramProvider = ({ children }) => {
  const [program, setProgram] = useState('ISET');
  return (
    <ProgramContext.Provider value={{ program, setProgram }}>
      {children}
    </ProgramContext.Provider>
  );
};

export default ProgramContext;
